import React, { useState } from 'react'
import styles from '@/components/quiz.module.css'
import { shuffle } from 'lodash'
import _ from 'lodash'

const questions = [
  {
    questionText: '🤔 How long have you used Cypress?',
    answerOptions: [
      'Never',
      'A few times',
      'Use it every day',
      'I never turn it off',
    ],
  },
  {
    questionText: '💎 Do you run Cypress on CI?',
    answerOptions: [
      'Tests are meant to be run locally',
      'CI is for noobs',
      'So much, I spell it "CIpress"',
      'I could not set up CI',
    ],
  },
  {
    questionText: '🏆 Do you prefer:',
    answerOptions: [
      'Walks on the beach',
      'Nice red wine',
      'Crisp autumn morning',
      'Skiing fresh powder',
    ],
  },
  {
    questionText: '👶 How do you describe your childhood?',
    answerOptions: [
      'Happy, but short',
      'School of hard knocks',
      'Still ongoing',
      'I was like little "cy" growing up to become "Cypress"',
    ],
  },
  {
    questionText: '⏱ Cypress command timeout is:',
    answerOptions: [
      'Too short to be honest',
      'Too long, should be in milliseconds',
      '4 seconds is perfect',
      'I set custom timeout on each command in the test',
    ],
  },
  {
    questionText: '📏 Do you prefer tests to be:',
    answerOptions: [
      'Short: Arrange - Act - Assert',
      'Meandering like a river',
      '80/20 rule: 80 tests with 20 commands each',
      'Each test should do exactly what it needs to do',
    ],
  },
  {
    questionText: '📚 Cypress Docs should add a section:',
    answerOptions: [
      'With cocktail recipes',
      'Talk about non-Cypress things for once',
      'Add more sections?! They need to be trimmed!',
      'Use passive voice more',
    ],
  },
  {
    questionText: '👁 Do you prefer learning by:',
    answerOptions: ['Reading', 'Doing', 'Watching videos', 'Learning'],
  },
  {
    questionText: '🚚 Should tests use semi-colons?',
    answerOptions: [
      'Yes, of course',
      'No, why should they',
      '2 spaces',
      'Tabs all the way',
    ],
  },
  {
    questionText: '🎬 My favorite movie is:',
    answerOptions: ['Rush Hour', 'Die Hard', 'Matrix', 'Netflix documentaries'],
  },
]

const commands = [
  [
    `
    🎉 You are the cy.intercept!

    You love everything new, and you are not afraid to take on new
    challenges. I wish I were as cool as you.
  `,
    'cy.intercept',
  ],
  [
    `
    Wow, turns out your command is cy.contains 🤔

    We don't really know what it means. Probably a good thing.
  `,
    'cy.contains',
  ],
  [
    `
    👏 Our data indicate you are closest to cy.within

    You are waiting to be discovered and appreciated!
    At least you are not cy.root, no one knows about cy.root
  `,
    'cy.within',
  ],
  [
    `
    👍 Definitely cy.fixture.

    You are a super useful command,
    the entire organization cannot function without you.
  `,
    'cy.fixture',
  ],
  [
    `
    💎 You are cy.contains

    BUT you are the cy.contains(selector, regexp) form,
    which is even better, nicely done 👏
  `,
    'cy.contains(selector, regexp)',
  ],
  [
    `
    Hmm, we have some good news 👍 and some bad news 👎

    Your profile fits the cy.route command: super useful,
    has been THE command to know for a while.

    But you are deprecated, and need to quickly level up
    to cy.intercept, ok. So no time to waste!
  `,
    'cy.route',
  ],
  [
    `
    You are the cy.task 👻

    Your profile fits, you love to escape the boring
    confines of the browser and roam freely in the Node
    world 🌎
  `,
    'cy.task',
  ],
  [
    `
    Sad news, we could not determine your Cypress command.

    Your answers kind of fit all of them.

    So you must be a ... custom command! 😋
  `,
    'custom command',
  ],
  [
    `
    🙀 You are the .should assertion command.

    You know what you want and you assert it strongly.
  `,
    '.should assertion',
  ],
  [
    `
    I am sorry to inform you,
    but you seem to be a cy.on event listener.

    Well, at least you are not a Cypress.on event listener,
    those folks don't even have a test context!
  `,
    'cy.on event listener',
  ],
  [
    `
    cy.stub

    Sneaky!
  `,
    'cy.stub',
  ],
  [
    `
    cy.spy 🕵🏻‍♂️

    With a tendency to slip into cy.stub mode
  `,
    'cy.spy',
  ],
  [
    `
    You are cy.click, but you really want to be cy.dblclick

    A story of our lives, isn't it? Never happy with who we are,
    always wanting more...
  `,
    'cy.click',
  ],
  [
    `
    cy.hover

    Ughh, it does not exist yet, so your time is yet to come.
  `,
    'cy.hover',
  ],
  [
    `
    cy.getCookie

    Without you a modern web would be impossible and it shows.
  `,
    'cy.getCookie',
  ],
  [
    `
    Do you have kids? Cause you are cy.parent!
  `,
    'cy.parent',
  ],
  [
    `
    You might be cy.reload

    Careful, buddy, do not get into troubles.
  `,
    'cy.reload',
  ],
  [
    `
    😖 cy.then

    Well, to be honest, it is not good news.
    You look promising, but there is something ...
    like you are always ready to confuse everyone or something.
  `,
    'cy.then',
  ],
  [
    `
    You might be cy.viewport 📺

    You see things the way others see them, be it on
    desktop or on mobile.
  `,
    'cy.viewport',
  ],
  [
    `
    Definitely cy.visit 👍

    Everything starts with you, but never ends.
  `,
    'cy.visit',
  ],
  [
    `
    You are Cypress.Bluebird

    Nicely done, really useful bundled library.
  `,
    'Cypress.Bluebird',
  ],
  [
    `
    You are Lodash Cypress._ 🎉

    A versatile Jack of all trades, you excel
    in many things, and your repo has no open issues.
  `,
    'Cypress._',
  ],
  [
    `
    cy.trigger 🔥

    Hey, take it easy!
  `,
    'cy.trigger',
  ],
  [
    `
    Maybe cy.check ✅

    But only if you come from Czech Republic. Otherwise you
    might be cy.click
  `,
    'cy.check',
  ],
  [
    `
    How about cy.not?

    Probably NOT what you expected
  `,
    'cy.not',
  ],
]

export default function Quiz({ randomizedQuestions }) {
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const [showScore, setShowScore] = useState(false)

  const handleAnswerOptionClick = () => {
    const nextQuestion = currentQuestion + 1
    if (nextQuestion < randomizedQuestions.length) {
      setCurrentQuestion(nextQuestion)
    } else {
      setShowScore(true)
    }
  }

  const pickedCommand =
    commands[_.random(0, commands.length - 1)] || commands[0]
  const commandName = pickedCommand[1]
  const url = 'https://cypress.tips/which-cypress-command-are-you'
  const tweet = [
    `I took the "Which Cypress command are you" quiz and I am a ${commandName}!`,
    `Take the quiz at ${url}\n`,
    'cc @bahmutov @cypress_io',
  ].join(' ')

  const encodedTweet =
    (typeof window !== 'undefined' && window.encodeURI(tweet)) || ''
  const tweetHref = `https://twitter.com/intent/tweet?text=${encodedTweet}`

  return (
    <>
      <div className={styles.appContainer}>
        <div className={styles.app}>
          {showScore ? (
            <>
              <div className={styles.scoreSection}>
                {pickedCommand[0].split('\n\n').map((s, k) => (
                  <div key={k}>{s}</div>
                ))}
                <div className={styles.quizActions}>
                  <div className={styles.tweetQuizResults}>
                    Tweet my{' '}
                    <a
                      href={tweetHref}
                      target="_blank"
                      title="Tweet my Cypress command"
                    >
                      results
                    </a>
                  </div>
                  <div className={styles.takeQuizAgain}>
                    Take the quiz{' '}
                    <a href="/which-cypress-command-are-you">again</a>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={styles['question-section']}>
                <div className={styles['question-count']}>
                  <span>Question {currentQuestion + 1}</span>/
                  {randomizedQuestions.length}
                </div>
                <div className={styles['question-text']}>
                  {randomizedQuestions[currentQuestion].questionText}
                </div>
              </div>
              <div className={styles['answer-section']}>
                {randomizedQuestions[currentQuestion].answerOptions.map(
                  (answerOption, k) => (
                    <button key={k} onClick={() => handleAnswerOptionClick()}>
                      {answerOption}
                    </button>
                  ),
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export async function getServerSideProps(context) {
  const randomizedQuestions = shuffle(questions)

  return {
    props: {
      randomizedQuestions,
    },
  }
}
